export default {
  /**
   *  任务状态
   * **/
  taskStatus: {
    processing: 1,       // 任务进行中
    sucess: 2,           //任务成功
    failure: 3,         // 任务失败
    expired: 4          // 任务过期
  },
  asyncFileExportType: {
    proofOfHoursByTask: 1,  // 学时证明
    trainingRecordByTask:  2 //学习记录
  }
}



// WEBPACK FOOTER //
// ./src/pages/trainingManagement/component/exportFile/exportFileConstant.js